require('./brokerCreateTransferOfDerivativesStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const BrokerTransferOfDerivatives = require('components/broker/brokerTransferOfDerivatives/brokerTransferOfDerivatives');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @constants
const { FIRST_STEP, HYPHEN } = require('constants/index');

const BrokerCreateTransferOfDerivativesStep2 = props => {
    const {
        immAccounts,
        immBrokerCreateTransferOfDerivatives,
        immBrokerWallets,
        actions,
        cancelButton,
        nextButton
    } = props;

    const selectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'selectedOriginDerivative']
    );

    const destinationAccount = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'destinationAccount']
    );

    const immOriginFuture = immBrokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === selectedOriginDerivative
    );

    const immDestinationAccount = immAccounts.get(destinationAccount);

    const originAccountName = immOriginFuture.get('descripcion') ? immOriginFuture.get('descripcion').trim() : HYPHEN;
    const originAccountNumber = immOriginFuture.getIn(['ibanComplex', 'codbban']);
    const originAccountBalance = immOriginFuture.getIn(['saldoActual', 'importe']);
    const originAccountBalanceCurrency = immOriginFuture.getIn(['saldoActual', 'divisa']);

    const destinationAccountName = immDestinationAccount.get('description') ? immDestinationAccount.get('description').trim() : HYPHEN;
    const destinationAccountNumber = immDestinationAccount.getIn(['ibanComplex', 'codbban']);
    const destinationAccountBalance = immDestinationAccount.getIn(['balance', 'amount']);
    const destinationAccountBalanceCurrency = immDestinationAccount.getIn(['balance', 'currency']);

    const amountToTransfer = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'amount']
    );
    const amountToTransferCurrency = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'amountCurrency']
    );

    const isLoading = immBrokerCreateTransferOfDerivatives.get('loading');
    const operative = formatText('operatives-brokerTransferOfDerviatives');

    return (
        <WizardStep
            actions={actions}
            cancelButton={cancelButton}
            nextButton={nextButton}
            position="last"
            immFinalButton="broker-transferOfDerivativesCreateSubmit"
            isLoading={isLoading}
        >
            <h4 className="broker-create-transfer-of-derivative-step2__title">
                <FormattedText value="broker-transferOfDerivativesCreateSummary"/>
            </h4>
            <h4 className="broker-create-transfer-of-derivative-step2__subtitle">
                <FormattedText value="broker-transferOfDerivativesCreateCheckData"/>
            </h4>
            <ContactCenterRender>
                <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
            </ContactCenterRender>
            <BrokerTransferOfDerivatives
                showCreationDate={false}
                originAccountName={originAccountName}
                originAccountNumber={originAccountNumber}
                originAccountBalance={originAccountBalance}
                originAccountBalanceCurrency={originAccountBalanceCurrency}
                destinationAccountName={destinationAccountName}
                destinationAccountNumber={destinationAccountNumber}
                destinationAccountBalance={destinationAccountBalance}
                destinationAccountBalanceCurrency={destinationAccountBalanceCurrency}
                amountToTransfer={amountToTransfer}
                amountToTransferCurrency={amountToTransferCurrency}
            />
            <ContactCenterRender>
                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
            </ContactCenterRender>
        </WizardStep>
    );
};

BrokerCreateTransferOfDerivativesStep2.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerCreateTransferOfDerivatives: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerCreateTransferOfDerivativesStep2.defaultProps = {
    cancelButton: true,
    nextButton: true
};

module.exports = BrokerCreateTransferOfDerivativesStep2;